function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useQuery } from '@tanstack/react-query';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { fetchUserAccessPage } from '../../../cores/api/api-dashboard';
import MonthFilter from '../filter/month-filter';
import Table from 'antd/es/table';
export default function ModalUserActivity({ columns, filterParams, onCancel }) {
    var _a, _b, _c;
    const _useState = useState({
        page: 1,
        start_date: (_a = filterParams.start_date) !== null && _a !== void 0 ? _a : dayjs().startOf('month').format('YYYY-MM-DD'),
        end_date: (_b = filterParams.end_date) !== null && _b !== void 0 ? _b : dayjs().endOf('month').format('YYYY-MM-DD')
    }), _useState2 = _slicedToArray(_useState, 2), params = _useState2[0], setParams = _useState2[1];
    const _useQuery = useQuery({
        queryKey: ['fetchUserAccessPage', params],
        queryFn: () => fetchUserAccessPage(params)
    }), data = _useQuery.data, isFetching = _useQuery.isFetching, isLoading = _useQuery.isLoading;
    return /*#__PURE__*/ React.createElement(Modal, {
        title: "\u30A2\u30AF\u30BB\u30B9\u8A73\u7D30",
        open: true,
        onCancel: onCancel,
        width: "90vw",
        footer: null,
        closable: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "top-4 z-50"
    }, /*#__PURE__*/ React.createElement(MonthFilter, {
        onChange: (start_date, end_date) => setParams(prev => _objectSpread(_objectSpread({}, prev), {}, {
            start_date,
            end_date
        }))
    })), /*#__PURE__*/ React.createElement("div", {
        className: "min-h-[400px] mt-10"
    }, /*#__PURE__*/ React.createElement(Table, {
        rowKey: "id",
        bordered: true,
        loading: isFetching || isLoading,
        dataSource: (_c = data === null || data === void 0 ? void 0 : data.data) !== null && _c !== void 0 ? _c : [],
        columns: columns,
        pagination: {
            total: data === null || data === void 0 ? void 0 : data.pagination.total_pages,
            showSizeChanger: false
        },
        onChange: p => setParams(prev => _objectSpread(_objectSpread({}, prev), {}, {
            page: p.current
        })),
        size: "large"
    })));
}
